/*    
<summary>
  This functional component "ChangePassword" defines the props like initial values and functions for the child form 
  component.
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/

import base64 from "base-64";
import { observer } from "mobx-react";
import toast from "react-hot-toast";
import React, { useEffect } from "react";
import { useStore } from "../../../../contexts/store-provider";
import { formatMessage } from "../../../../translations/format-message";
import { IUpdateCustomerPassword, IUpdateStorePassword } from "../../../../models/forms/IChangePassword";
import ChangePasswordForm from "../../../user/forms/change-password-form";
import { initialStateUpdatePassword } from "../../../../core/initialState/change-password-state";
import customerManagementStore from "../../../../core/stores/customer-management-store";
import ChangeCustomerPasswordForm from "../forms/change-customer-password-form";
import { safeBase64Encode } from "../../../../constants/constants";


interface IProps {
  id: number;
  modalClosed: () => void;
}

let ChangePassword: React.FC<IProps> = (props) => {
  const { customerManagementStore } = useStore();
  const {
    UpdateCustomerPasswordService,
    changeCustomerPasswordState,
    resetChangePassword,
  
  } = customerManagementStore;

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
   * dependency "changePasswordSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (changeCustomerPasswordState.success) {
      toast.success(formatMessage("updated_success"));
      onModalClosed();
    }
  }, [changeCustomerPasswordState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while 
   * dependency "changePasswordError" of the useEffect changed.
   */
  useEffect(() => {
    if (changeCustomerPasswordState.error) {
      toast.error(formatMessage(changeCustomerPasswordState.error));
      resetChangePassword();
    }
  }, [changeCustomerPasswordState.error]);

  /**
   * This function changes the user password by provides new password and user Id  to "chagePassword" store funtion that 
   * send the request to Api.
   */
  const onSubmitForm = (values: IUpdateCustomerPassword) => {
    let submitData: IUpdateCustomerPassword;
    submitData = {
      CustomerId: props.id,
      NewPassword: safeBase64Encode(values.NewPassword),
    };
    UpdateCustomerPasswordService(submitData);
  };

  /**
   * This function closes the pop up modal and reset ChangePassword observables (success, inprogress and error).
   */
  const onModalClosed = () => {
    resetChangePassword();
    props.modalClosed();
  };

  return (
    <ChangeCustomerPasswordForm
      id={props.id}
      initialValues={initialStateUpdatePassword}
      submitHandler={onSubmitForm}
      onModalClosed={onModalClosed}
      loading={changeCustomerPasswordState.inProgress}
    />
  );
};

export default observer(ChangePassword);
